import React, { memo } from "react";
import { UncontrolledTooltip } from "reactstrap";

// Redux
import { useSelector, useDispatch } from "react-redux";

//components
import WidgetButton from "./WidgetsButtons";
import Notepad from "../../../Notepad/Notepad";

//i18n
import { withTranslation } from "react-i18next";

import {
  getNotepad,
  setNotepadContent,
  updateNotepad,
  toggleNotepad,
} from "../../../../store/notepad/actions";
import useHasPermission from "../../../../hooks/useHasPermission";

const Widgets = ({
  t,
  skillSummaryActived,
  isTicket = false,
  onclickOne,
  onclickTwo,
  onclickThree,
  onclickScripts,
  onClickSummary,
  fillcolorOne,
  fillcolorTwo,
  styleThree,
  styleScripts,
  styleSummary,
  fillcolorOneL,
  fillcolorTwoL,
  widgetExpanded,
  setWidgetExpanded,
  chatId,
  fillcolorFour,
  fillcolorFourL,
  hideEngagementHistory,
  fillColorAdditionalField,
  fillColorAdditionalFieldL,
  onClickAdditionalField,
  handleCustomWidgets,
  customWidgets,
}) => {
  const dispatch = useDispatch();
 
  const { content } = useSelector((state) => state.Notepad);
  const { conversations: widgetsConversation, loading: isGetWidgets } =
    useSelector((state) => state.CustomWidgets);
  const widgets = widgetsConversation?.[chatId] || {};

  const hasPermissionAditionalFieldsRead = useHasPermission('additional_fields_widgets', 'get');

  const { mainTheme } = useSelector((state) => state.Layout);
  const toggle = () => {
    dispatch(toggleNotepad());
  };

  const { isOpen } = useSelector((state) => state.Notepad);

  const handleGetNotepad = () => {
    dispatch(getNotepad());
  };

  const handleUpdateNotepad = (content) => {
    dispatch(updateNotepad({ text: content }));
    dispatch(setNotepadContent(content));
  };

  function fillColor(widgetId) {
    if (mainTheme === "light") {
      return customWidgets[widgetId] ? fillcolorFourL[0] : fillcolorFourL[1];
    }

    return customWidgets[widgetId] ? fillcolorFour[0] : fillcolorFour[1];
  }

  return (
    <div
      className="d-flex flex-row align-items-center widget-show-animation"
      style={{
        transform: !widgetExpanded ? "none" : "translateX(7em)",
        marginTop: 73,
        pointerEvents: widgetExpanded ? "none" : "visible",
      }}
    >
      <div>
        <button
          type="button"
          className="btn btn-primary pt-2 pb-2 pl-0 pr-0"
          style={{ pointerEvents: "all" }}
          onClick={() => {
            setWidgetExpanded((prev) => !prev);
          }}
        >
          <i
            className={`icon-conversation-arrow mdi mdi-chevron-right ${
              widgetExpanded ? "active" : ""
            } font-size-24 `}
          />
        </button>
      </div>

      <div
        className="widget-show-container widget-show-animation"
        style={{
          opacity: !widgetExpanded ? "1" : "0",
          visibility: !widgetExpanded ? "visible" : "hidden",
        }}
      >
        <div>
          <h5
            style={{
              textAlign: "end",
            }}
          >
            Widgets
          </h5>
        </div>
        <div className="mr-3">
          {hideEngagementHistory && (
            <div>
              <ul
                className="list-inline user-chat-nav text-right"
                style={{ marginTop: "10px", marginBottom: "10px" }}
                onClick={onclickOne}
                id="engagement-history"
              >
                <WidgetButton
                  cx="20"
                  cy="20"
                  r="20"
                  stroke={mainTheme === "light" ? "#74788d" : "#bfc8e2"}
                  strokLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1.2"
                  fillcolor={
                    mainTheme === "light" ? fillcolorOneL : fillcolorOne
                  }
                  transform="translate(12 12)"
                  d="M8 0C3.588 0 0 3.588 0 8s3.588 8 8 8 8-3.588 8-8-3.588-8-8-8zm0 1.067c3.835 0 6.933 3.098 6.933 6.933S11.835 14.933 8 14.933 1.067 11.835 1.067 8 4.165 1.067 8 1.067zM7.639 3.01c-.142.002-.279.06-.378.162-.098.103-.153.24-.15.383v4.8c0 .294.239.533.533.533h4.8c.144.002.281-.054.382-.154.102-.1.16-.236.16-.38 0-.142-.058-.28-.16-.38-.101-.1-.239-.155-.382-.153H8.178V3.556c.003-.145-.053-.284-.154-.386-.102-.103-.24-.16-.385-.159z"
                />
              </ul>
              <UncontrolledTooltip placement="left" target="engagement-history">
                {t("Engagement history")}
              </UncontrolledTooltip>
            </div>
          )}          
          <div>
            <ul
              className="list-inline user-chat-nav text-right"
              style={{ marginBottom: "10px" }}
              id="client-info"
              onClick={onclickTwo}
            >
              <WidgetButton
                cx="20"
                cy="20"
                r="20"
                fillcolor={mainTheme === "light" ? fillcolorTwoL : fillcolorTwo}
                stroke={mainTheme === "light" ? "#74788d" : "#bfc8e2"}
                strokLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M9.12 1.44L14.4 1.44M9.12 4.32L14.4 4.32M11.52 7.2L14.4 7.2M11.52 10.08L14.4 10.08M8.64 11.28H0V9.004c0-.852.559-1.6 1.376-1.842.765-.227 1.794-.442 2.944-.442 1.131 0 2.166.219 2.94.447.819.242 1.38.99 1.38 1.844v2.269zM1.92 2.4c0-1.326 1.074-2.4 2.4-2.4 1.326 0 2.4 1.074 2.4 2.4 0 1.326-1.074 2.88-2.4 2.88-1.326 0-2.4-1.554-2.4-2.88z"
                transform="translate(12 14)"
              />
              <UncontrolledTooltip placement="left" target="client-info">
                {t("Client info")}
              </UncontrolledTooltip>
            </ul>
          </div>
          {
            !isTicket && (<>            
              <div>
                <ul
                  className="list-inline user-chat-nav text-right"
                  style={{ marginBottom: "10px" }}
                  onClick={onclickThree}
                >
                  <i
                    style={styleThree}
                    className={`bx bx-message-square-detail font-size-22 text-muted ${
                      mainTheme === "light" ? "btn nav-btn-light" : "btn nav-btn"
                    }`}
                    id="quick-reply"
                  ></i>
                  <UncontrolledTooltip placement="left" target="quick-reply">
                    {t("Quick replies")}
                  </UncontrolledTooltip>
                </ul>
              </div>
              <div>
                  <ul
                    className="list-inline user-chat-nav text-right"
                    style={{ marginTop: "10px", marginBottom: "10px" }}
                    onClick={onclickScripts}
                  >
                    <i
                      style={styleScripts}
                      className={`bx bx-copy-alt font-size-22 text-muted ${
                        mainTheme === "light" ? "btn nav-btn-light" : "btn nav-btn"
                      }`}
                      id="widget-scripts"
                    ></i>
                  </ul>
                  <UncontrolledTooltip placement="left" target="widget-scripts">
                    {t("Scripts")}
                  </UncontrolledTooltip>
              </div>
            </>)
          }
           {
            !isTicket && skillSummaryActived && (
            <div>
                  <ul
                    className="list-inline user-chat-nav text-right"
                    style={{ marginTop: "10px", marginBottom: "10px" }}
                    onClick={onClickSummary}
                  >
                    <i
                      style={styleSummary}
                      className={`bx bxs-magic-wand font-size-22 text-muted ${
                        mainTheme === "light" ? "btn nav-btn-light" : "btn nav-btn"
                      }`}
                      id="widget-sumarizacao"
                    ></i>
                  </ul>
                  <UncontrolledTooltip placement="left" target="widget-sumarizacao">
                    {t("Conversation summarization")}
                  </UncontrolledTooltip>
              </div>
            )}
          <div>
            <ul
              className="list-inline user-chat-nav text-right"
              style={{ marginBottom: "10px" }}
              onClick={() => {
                if (!isOpen) {
                  toggle();
                  handleGetNotepad();
                }
              }}
            >
              <i
                className={`text-muted bx bx-notepad font-size-22 ${
                  mainTheme === "light" ? "btn nav-btn-light" : "btn nav-btn"
                } `}
                style={{
                  cursor: "pointer",
                  backgroundColor: isOpen && "#51A6F1",
                }}
                id="notepad"
              >
                <UncontrolledTooltip placement="left" target="notepad">
                  {t("Notepad")}
                </UncontrolledTooltip>
              </i>
            </ul>
          </div>
          {
            isTicket && hasPermissionAditionalFieldsRead && (
            <div>
              <ul
                className="list-inline user-chat-nav text-right"
                style={{ marginBottom: "10px" }}
                id="additional-field"
                onClick={onClickAdditionalField}
              >
                <WidgetButton
                  cx="20"
                  cy="20"
                  r="20"
                  fillcolor={mainTheme === "light" ? fillColorAdditionalFieldL : fillColorAdditionalField}
                  stroke={mainTheme === "light" ? "#74788d" : "#bfc8e2"}
                  strokLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="m2.513 12.833 9.022 5.04a.995.995 0 0 0 .973.001l8.978-5a1 1 0 0 0-.002-1.749l-9.022-5a1 1 0 0 0-.968-.001l-8.978 4.96a1 1 0 0 0-.003 1.749z"
                  done="m3.485 15.126-.971 1.748 9 5a1 1 0 0 0 .971 0l9-5-.971-1.748L12 19.856l-8.515-4.73zM20 8V6h2V4h-2V2h-2v2h-2v2h2v2z"
                  transform="translate(8 8)"
                  transformone="translate(8 8)"
                />
                <UncontrolledTooltip placement="left" target="additional-field">
                  {t("Aditional Fields")}
                </UncontrolledTooltip>
              </ul>
            </div>
            )
          }
          {isGetWidgets && (
            <>
              <div>
                <ul
                  className="list-inline user-chat-nav text-right"
                  style={{ marginBottom: "10px" }}
                  id={`custom-widget-loading`}
                >
                  <div
                    className="spinner-border text-secondary"
                    role="status"
                  />
                  <UncontrolledTooltip
                    placement="left"
                    target={`custom-widget-loading`}
                  >
                    {t("Loading Custom Widgets")}
                  </UncontrolledTooltip>
                </ul>
              </div>
            </>
          )}
          {Object.entries(widgets).map((el, key) => (
            <>
              {el[1]?.data && (
                <div>
                  <ul
                    className="list-inline user-chat-nav text-right"
                    style={{ marginBottom: "10px" }}
                    id={`custom-widget-${key}`}
                    onClick={() => {
                      handleCustomWidgets(el[0]);
                    }}
                  >
                    <WidgetButton
                      cx="20"
                      cy="20"
                      r="20"
                      fillcolor={fillColor(el[0])}
                      stroke={mainTheme === "light" ? "#74788d" : "#bfc8e2"}
                      strokLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M16.469,8.924l-2.414,2.413c-0.156,0.156-0.408,0.156-0.564,0c-0.156-0.155-0.156-0.408,0-0.563l2.414-2.414c1.175-1.175,1.175-3.087,0-4.262c-0.57-0.569-1.326-0.883-2.132-0.883s-1.562,0.313-2.132,0.883L9.227,6.511c-1.175,1.175-1.175,3.087,0,4.263c0.288,0.288,0.624,0.511,0.997,0.662c0.204,0.083,0.303,0.315,0.22,0.52c-0.171,0.422-0.643,0.17-0.52,0.22c-0.473-0.191-0.898-0.474-1.262-0.838c-1.487-1.485-1.487-3.904,0-5.391l2.414-2.413c0.72-0.72,1.678-1.117,2.696-1.117s1.976,0.396,2.696,1.117C17.955,5.02,17.955,7.438,16.469,8.924 M10.076,7.825c-0.205-0.083-0.437,0.016-0.52,0.22c-0.083,0.205,0.016,0.437,0.22,0.52c0.374,0.151,0.709,0.374,0.997,0.662c1.176,1.176,1.176,3.088,0,4.263l-2.414,2.413c-0.569,0.569-1.326,0.883-2.131,0.883s-1.562-0.313-2.132-0.883c-1.175-1.175-1.175-3.087,0-4.262L6.51,9.227c0.156-0.155,0.156-0.408,0-0.564c-0.156-0.156-0.408-0.156-0.564,0l-2.414,2.414c-1.487,1.485-1.487,3.904,0,5.391c0.72,0.72,1.678,1.116,2.696,1.116s1.976-0.396,2.696-1.116l2.414-2.413c1.487-1.486,1.487-3.905,0-5.392C10.974,8.298,10.55,8.017,10.076,7.825"
                      transform="translate(10 11)"
                    />
                    <UncontrolledTooltip
                      placement="left"
                      target={`custom-widget-${key}`}
                    >
                      {el[1].data?.title || t("Widgets")}
                    </UncontrolledTooltip>
                  </ul>
                </div>
              )}
            </>
          ))}
        </div>
        <Notepad
          isOpen={isOpen}
          toggle={toggle}
          saveNotepad={handleUpdateNotepad}
          value={content}
        />
      </div>
    </div>
  );
};
export default withTranslation()(memo(Widgets));
